import { useTranslation } from 'react-i18next';
import {
  Container,
  CompanyDetailsWrapper,
  RowGap,
  ContentWrapper,
  CompanyName,
  InfoText,
  imageStyle,
  imageContainerStyle,
  Row,
  InfoValue,
  BackWrapper,
  ToggleStateWrapper,
  ToggleStateLabel,
} from './MyModelsSinglePage.styled';
import { useNavigate, useParams } from 'react-router-dom';
import {
  AdaptiveImage,
  AdaptiveImageType,
} from 'components/AdaptiveImage/AdaptiveImage';
import { useSelector } from 'react-redux';
import { IRootReducerState } from 'store/store';
import BackButton from 'components/BackButton/BackButton';
import { RoutesConfig } from 'navigation/routes';
import ModelsCompanies from './ModelsCompanies/ModelsCompanies';
import { useGetMyModel, useTogglePublicModel } from './hooks';
import ToggleSwitch from 'components/ToggleSwitch/ToggleSwitch';
import { useBreakpointFlag } from 'utils/hooks/useBreakpointFlag';
import { useState } from 'react';
import { ConfirmModal } from 'components/Modals/ConfirmModal/ConfirmModal';

const MyModelsSinglePage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { id: modelId } = useParams();
  const { isSmallTablet } = useBreakpointFlag();
  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);

  const { company } = useSelector((state: IRootReducerState) => state.userInfo);

  const { data: modelData, isSuccess: isSuccessGetModel } = useGetMyModel(
    Number(modelId)
  );

  const { mutate: togglePublicModel, isLoading: isLoadingTogglePublicModel } =
    useTogglePublicModel();

  return (
    <Container>
      <BackWrapper>
        <BackButton
          destination={t('My Models')}
          onClick={() => navigate(RoutesConfig.MyModels.fullPath)}
        />
      </BackWrapper>
      <ContentWrapper>
        <AdaptiveImage
          imageStyle={imageStyle}
          containerStyle={imageContainerStyle}
          imageUrl={modelData?.image}
          type={AdaptiveImageType.MODEL}
          isSuccess={isSuccessGetModel}
        />
        <CompanyDetailsWrapper>
          <CompanyName>{modelData?.name}</CompanyName>
          <ToggleStateWrapper>
            <ToggleStateLabel>
              {modelData?.is_public ? t('Public') : t('Private')}
            </ToggleStateLabel>
            <ToggleSwitch
              isChecked={modelData?.is_public}
              onClick={() => {
                if (isLoadingTogglePublicModel) {
                  return;
                }
                setIsConfirmModalOpen(true);
              }}
              size={isSmallTablet ? 'small' : 'large'}
            />
          </ToggleStateWrapper>
          <Row>
            <RowGap>
              <InfoText>{t('Model ID')}:</InfoText>
              <InfoValue>{modelData?.id}</InfoValue>
            </RowGap>
            <RowGap>
              <InfoText>{t('Version ID')}:</InfoText>
              <InfoValue>{modelData?.last_version_id}</InfoValue>
            </RowGap>
          </Row>
          <Row>
            <RowGap>
              <InfoText>{t('Price list')}:</InfoText>
              <InfoValue>{modelData?.price_list}</InfoValue>
            </RowGap>
            <RowGap>
              <InfoText>{t('Price list version')}:</InfoText>
              <InfoValue>{modelData?.price_list_version}</InfoValue>
            </RowGap>
          </Row>
          <Row>
            <InfoValue>{modelData?.description}</InfoValue>
          </Row>
        </CompanyDetailsWrapper>
      </ContentWrapper>
      <ModelsCompanies
        modelId={Number(modelId)}
        companyId={Number(company.id)}
        isPublicModel={modelData?.is_public}
      />
      <ConfirmModal
        isOpen={isConfirmModalOpen}
        setIsOpen={setIsConfirmModalOpen}
        title={
          modelData?.is_public
            ? t('Make model private')
            : t('Make model public')
        }
        description={
          modelData?.is_public
            ? t(
                'This will revoke the access of all dealers.\nAre you sure you want to make this model private?'
              )
            : t(
                'This will grant access to all dealers.\nAre you sure you want to make this model public?'
              )
        }
        disabled={isLoadingTogglePublicModel}
        onConfirm={() => {
          togglePublicModel({
            modelId: Number(modelId),
            is_public: !modelData?.is_public,
          });
          setIsConfirmModalOpen(false);
        }}
        onCancel={() => setIsConfirmModalOpen(false)}
      />
    </Container>
  );
};

export default MyModelsSinglePage;
